import get from 'lodash/get';
import { isNumeric, isUuid, isNonEmptyString } from '../../js/app/react/validators';
import { fetchGoalWhatIfData, setCurrentViewId } from './WhatIfsActions';
import {
  nullableUrlSelector,
  nullableFpIdSelector,
  nullableSelectedGoalIdSelector,
} from './WhatIfsSelector';

const resetWhatIfs = () => {
  const { ADV } = window;
  const dispatch = get(window, 'ADV.store.dispatch', null);
  if (!dispatch) {
    throw Error('refreshWhatIfsIfNecessary requires ADV.store.dispatch');
  }

  const getState = get(window, 'ADV.store.getState', null);
  if (!getState) {
    throw Error('refreshWhatIfsIfNecessary requires ADV.store.getState');
  }
  const state = getState();

  let clientId;
  if (ADV.util.env('isAdviserArea')) {
    clientId = get(ADV.store.getState(), 'AdviserArea.currentClient.Id', null);
  }

  if (ADV.util.env('isConsumerArea')) {
    clientId = ADV.entities.getUserObject().Id || null;
  }

  const props = { clientId };
  if (!isNumeric(clientId)) {
    throw Error('refreshWhatIfsIfNecessary requires a valid clientId');
  }
  const fpId = nullableFpIdSelector(state, props);
  if (!isUuid(fpId)) {
    return;
  }

  const goalId = nullableSelectedGoalIdSelector(state, props);
  if (!isUuid(goalId)) {
    return;
  }

  const url = nullableUrlSelector(state, props);
  if (!isNonEmptyString(url)) {
    return;
  }
  dispatch(fetchGoalWhatIfData(clientId, fpId, goalId, url));
  dispatch(setCurrentViewId(clientId, goalId, null));
};

export default resetWhatIfs;
